import { useEffect } from "react";

const useInactivityLogout = () => {
  useEffect(() => {
    let timer;
    const LIMIT = 1 * 60 * 1000;

    const clearSession = () => {
      localStorage.removeItem("session_id");
    };

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(clearSession, LIMIT);
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      clearTimeout(timer);
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);
};

export default useInactivityLogout;
